export default {
  install (Vue) {
    // 阻止重复点击按钮造成请求重发
    Vue.directive('preventReClick', {
      bind: (el, binding) => {
        let cbFun
        el.addEventListener('click', event => {
          if (!cbFun) { // 第一次执行
            cbFun = setTimeout(() => {
              cbFun = null
            }, binding.value || 1000) // binding.value // 防抖时间debounceTime: 用户若不设置防抖时间，则默认1s
          } else {
            event && event.stopImmediatePropagation()
          }
        }, true)
      }
    })
  }
}
